var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [_vm._v(_vm._s(_vm.filterFold ? "展开筛选" : "收起筛选"))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "快递单号" },
                                  model: {
                                    value: _vm.form.shipping_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "shipping_num", $$v)
                                    },
                                    expression: "form.shipping_num"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "打标id" },
                                  model: {
                                    value: _vm.form.dbid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "dbid", $$v)
                                    },
                                    expression: "form.dbid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "工单id" },
                                  model: {
                                    value: _vm.form.work_id,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "work_id", $$v)
                                    },
                                    expression: "form.work_id"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "状态" },
                                    model: {
                                      value: _vm.form.status,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "status", $$v)
                                      },
                                      expression: "form.status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.searchOptions.da_biao_status,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: { width: "150px" },
                                    attrs: { placeholder: "入库仓区" },
                                    model: {
                                      value: _vm.form.to_where,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "to_where", $$v)
                                      },
                                      expression: "form.to_where"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { label: "全部", value: "" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.searchOptions.dbid_to_where,
                                      function(item) {
                                        return _c("el-option", {
                                          key: item.key,
                                          attrs: {
                                            label: item.label,
                                            value: item.key
                                          }
                                        })
                                      }
                                    )
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "拆包提交时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期",
                                    "default-time": ["06:00:00", "06:00:00"]
                                  },
                                  model: {
                                    value: _vm.form.unpack_submit_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "unpack_submit_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.unpack_submit_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "" },
                                    on: { click: _vm.reset }
                                  },
                                  [_vm._v("重置")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.form.shipping_num && _vm.resData.base_info
        ? _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("div", { staticClass: "galy-header" }, [
                _vm._v("寄回运单号:" + _vm._s(_vm.form.shipping_num))
              ]),
              _vm._v(" "),
              _c(
                "el-row",
                { staticStyle: { "margin-top": "10px" }, attrs: { spa: 50 } },
                [
                  _c(
                    "el-col",
                    { staticClass: "border", attrs: { span: 11 } },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _vm._v(
                            "用户id: " + _vm._s(_vm.resData.base_info.user_id)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n            包裹状态:\n            " +
                              _vm._s(
                                _vm.resData.base_info.as_package_package_status
                              ) +
                              "\n          "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _vm._v(
                            "接收人: " +
                              _vm._s(_vm.resData.base_info.receive_admin)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "是否破损: " +
                              _vm._s(_vm.resData.base_info.is_broken)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 8 } }, [
                        _c("p", [
                          _vm._v(
                            "接收时间: " +
                              _vm._s(_vm.resData.base_info.receive_time)
                          )
                        ])
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 2 } }, [_vm._v(" ")]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "border", attrs: { span: 11 } },
                    [
                      _c(
                        "el-col",
                        {
                          staticStyle: { "border-right": "#ccc dashed 1px" },
                          attrs: { span: 6 }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "工单数量: " +
                                _vm._s(_vm.resData.base_info.work_num)
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "工单商品数量: " +
                                _vm._s(_vm.resData.base_info.goods_number)
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "padding-left": "20px" },
                          attrs: { span: 6 }
                        },
                        [
                          _c("p", [
                            _vm._v(
                              "拆包数量: " +
                                _vm._s(_vm.resData.base_info.unpack_num)
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("p", [
                          _vm._v(
                            "正常品: " +
                              _vm._s(_vm.resData.base_info.normal_num)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "退换货: " + _vm._s(_vm.resData.base_info.thh_num)
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("p", [
                          _vm._v(
                            "次品: " + _vm._s(_vm.resData.base_info.cp_num)
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "无数据: " +
                              _vm._s(_vm.resData.base_info.no_data_goods_num)
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [_vm._v("\n        点货明细(不含无数据)\n      ")]
            ),
            _vm._v(" "),
            _vm.resData.list
              ? _c(
                  "div",
                  { staticStyle: { "margin-bottom": "0" } },
                  [
                    _vm.resData
                      ? _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.tableLoading,
                                expression: "tableLoading"
                              }
                            ],
                            ref: "multipleTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              height: "800",
                              data: _vm.resData.list,
                              "tooltip-effect": "dark"
                            }
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                label: "序号",
                                width: "100",
                                type: "index"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "dbid",
                                label: "打标id",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "goods_name",
                                label: "商品名称",
                                width: "250"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "goods_no",
                                label: "货号",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "co_val",
                                label: "颜色",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "si_val",
                                label: "尺码",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "sku",
                                label: "sku",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "work_id",
                                label: "工单id",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "blp_type",
                                label: "登记类型",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "problem_size",
                                label: "次品问题尺寸",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "problem_type",
                                label: "问题类型",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "dbid_to_where",
                                label: "入库仓区",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "desk_no",
                                label: "工作台",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "blp_note",
                                label: "备注",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "create_time",
                                label: "打标时间",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "admin_name",
                                label: "拆包人",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "da_biao_record_status",
                                label: "状态",
                                width: "150"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "stock_in_time",
                                label: "入库时间",
                                width: "200"
                              }
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                align: "center",
                                "show-overflow-tooltip": "",
                                prop: "exchange_calc_date",
                                label: "计算开始时间",
                                width: "200"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper ,sizes",
                        total: _vm.resData.count,
                        "page-size": _vm.form.pagesize,
                        "page-sizes": [50, 100, 200, 500, 1000]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.handleSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fdd69f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fdd69f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/aspackage/AsPackageDetail.vue
// module id = null
// module chunks = 